<template>
  <div>
    <v-row class="mt-2">
      <v-responsive width="100%" />
      <v-col :xs="12" :sm="12" :md="3" :lg="2">
        <v-text-field type="date" label="From Date" outlined dense v-model="search.from_date">
        </v-text-field>
      </v-col>
      <v-col :xs="12" :sm="12" :md="3" :lg="2">
        <v-text-field type="date" label="End Date" outlined dense v-model="search.to_date">
        </v-text-field>
      </v-col>
      <v-col :xs="12" :sm="12" :md="3" :lg="3" v-if="(ROLE == 'Owner')">
        <v-select label="Branch" item-text="name" item-value="id" :items="branch" outlined dense
          v-model="search.branch_id">
        </v-select>
      </v-col>
      <v-col :xs="12" :sm="12" :md="6" :lg="5">
        <v-btn small color="darkblue" class="white--text mx-1" @click.stop="init">Submit <v-icon
            right>mdi-magnify</v-icon></v-btn>
        <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
          <v-icon right>mdi-close-circle-multiple </v-icon>
        </v-btn>
        <v-menu open-on-hover top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small color="success"  v-bind="attrs" v-on="on" @click.stop="exportExcellByItem()">
              Excell<v-icon right> mdi-file-excel</v-icon>
            </v-btn>
          </template>
        </v-menu>
        <v-menu open-on-hover top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small color="secondary" class="mx-1" v-bind="attrs" v-on="on"
              @click.stop="downloadPdfItem()">
              PDF<v-icon right> mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="my-0">
      <v-col xs="12" sm="12" md="12" lg="12">
        <v-data-table :loading="loading" :headers="headers" :items="ByItem.data" class="elevation-3" hide-default-footer>
          <template v-slot:[`item.no`]="{ item }">
            {{ ByItem.data.indexOf(item) + 1 }}
          </template>
          <template v-slot:[`item.service`]="{ item }">
            {{ item.service ?? 0 }}
          </template>
          <template v-slot:[`item.sales_order.order_date`]="{ item }">
            {{
              new Date(item.sales_order.order_date).toLocaleDateString("id-ID", { timeZone: "Asia/Jakarta" })
            }}
          </template>
          <template v-slot:[`item.sales_order.order_time`]="{ item }">
            {{
              new Date(item.sales_order.order_date).toLocaleTimeString("id-ID", { timeZone: "Asia/Jakarta" })
            }}
          </template>
          <template v-slot:[`item.price`]="{ item }">
            <p class="mt-3">{{ item.price | currency("", 0, { symbolOnLeft: false, }) }}</p>
          </template>
          <template v-slot:[`item.subtotal`]="{ item }">
            <p class="mt-3">{{ item.price * item.qty | currency("", 0, { symbolOnLeft: false, }) }}</p>
          </template>
          <template v-slot:[`item.item.ppn_amount`]="{ item }">
            <p class="mt-3">{{ item.item.ppn_amount | currency("", 0, { symbolOnLeft: false, }) }}</p>
          </template>
          <template v-slot:[`item.sales_order.grand_total`]="{ item }">
            <p class="mt-3">{{ item.sales_order.grand_total | currency("", 0, { symbolOnLeft: false, }) }}</p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip color="dark" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" color="primary" v-bind="attrs" icon small @click.stop="view(item.id)" v-on="on">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>View Sales Order</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>
  
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ByItem",
  data() {
    return {
      headers: [
        { text: "No", value: "no", width: "70px" ,class: "primary white--text"},
        { text: "Order Date", value: "sales_order.order_date", width: "150px" ,class: "primary white--text"},
        { text: "Order Time", value: "sales_order.order_time", width: "150px" ,class: "primary white--text"},
        { text: "Sub Group", value: "item.subgroup.name", width: "150px" ,class: "primary white--text"},
        { text: "Item Name", value: "item.name", width: "150px" ,class: "primary white--text"},
        { text: "Unit Price", value: "price", width: "150px" ,class: "primary white--text"},
        { text: "Qty", value: "qty", width: "100px" ,class: "primary white--text"},
        { text: "Sub Total", value: "subtotal", width: "150px" ,class: "primary white--text"},
        { text: "Disc", value: "discount_nominal", width: "150px" ,class: "primary white--text"},
        { text: "Service", value: "service", width: "150px" ,class: "primary white--text"},
        { text: "Vat", value: "item.ppn_amount", width: "100px" ,class: "primary white--text"},
        { text: "Total Amount", value: "sales_order.grand_total", width: "150px" ,class: "primary white--text"},
      ],
      disabled: false,
      loading: false,
      expanded: [],
      loading_download: false,
      status: ["ONPROGRESS", "DONE", "VOID", "HOLD", "CANCEL"],
      search: {
        from_date: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-01`,
        to_date: new Date().toJSON().slice(0, 10),
        branch_id: null,
      },
      branch: [],
      total_transaction: 0,
      total_amount: 0,
      total_cash: 0,
      total_card: 0,

    };
  },

  methods: {
    ...mapMutations("daily_sales_order", ["SET_BY_ITEM", "SET_CURRENT_PAGE"]),
    sumField(key) {
      return this.ByItem.data.reduce((a, b) => a + (b[key] || 0), 0)
    },
    async init() {
      this.loading = true;
      this.disabled = true;
      let params = {
        page: this.page,
        from_date: this.search.from_date,
        to_date: this.search.to_date,
        branch_id: this.search.branch_id,
      };

      await this.$axios
        .get("/reports/items", {
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_BY_ITEM(data.items);
          this.loading = false;
          this.disabled = false;
        });
    },

    async getBranch() {
      await this.$axios
        .get("/master/branches", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.branch = data.branch.data;
        });
    },

    view(id) {
      this.$router.push("/daily-sales-order/view/" + id);
      this.$router.go();
    },


    exportExcellByItem: async function () {
      this.loading = true;
      let params = {
        from_date: this.search.from_date,
        to_date: this.search.to_date,
        branch_id: this.search.branch_id,
      };
      await this.$axios
        .get(
          "/reports/items/export/",
          {
            params: params,
            headers: {
              Authorization: this.$store.getters["auth/Token"],
            },
          }
        ).then(({ data }) => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const a = document.createElement('a');
          a.href = url;
          a.setAttribute('download', 'daily-sales-order-items.csv');
          document.body.appendChild(a);
          a.click();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          console.log("error");
        });
    },

    async downloadPdfItem() {
      let params = {
        from_date: this.search.from_date,
        to_date: this.search.to_date,
        branch_id: this.search.branch_id,
      };
      await this.$axios
        .get(`/reports/items/pdf`, {
          method: "GET",
          responseType: "arraybuffer",
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then((response) => {
          this.loading = false;
          let blob = new Blob([response.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `item-report.pdf`;
          link.click();
          window.close();
        });
    },
    clear() {
      this.page = 1;
      this.search = {
        from_date: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-01`,
        to_date: new Date().toJSON().slice(0, 10),
        branch_id: null,
      };
      this.init();
    },
  },

  created() {
    this.init();
    this.getBranch();
  },

  watch: {
    currentPage(newValue) {
      this.page = newValue;
      this.init();
    },
  },
  computed: {
    ...mapGetters("daily_sales_order", {
      ByItem: "ByItem",
    }),
    ...mapGetters("auth", {
      CAN: "Can",
    }),
    ...mapGetters("auth", {
      ROLE: "Role",
    }),

    currentPage: {
      get() {
        return this.ByItem.current_page;
      },
      set(val) {
        return this.$store.commit("daily_sales_order/SET_CURRENT_PAGE", val);
      },
    },
    lastPage: {
      get() {
        return this.ByItem.last_page;
      },
    },
  },
};
</script>
<style scoped>
::v-deep .v-data-table-header {
  background-color: #ebebeb59;
}

::v-deep th {
  color: #000 !important;
}
</style>